import { useEffect } from 'react'

/**
 * When the widget runs inside an iframe (e.g. embedded on fforsikring.dk),
 * post the document height to the parent so it can size the iframe accordingly.
 * The parent must listen for `{ type: 'leadflow:height', height: <px> }` messages.
 */
export function IframeResize() {
  useEffect(() => {
    if (typeof window === 'undefined' || window.parent === window) return

    let lastHeight = 0
    const send = () => {
      const h = document.documentElement.scrollHeight
      if (h === lastHeight) return
      lastHeight = h
      window.parent.postMessage({ type: 'leadflow:height', height: h }, '*')
    }

    send()
    const ro = new ResizeObserver(send)
    ro.observe(document.documentElement)
    window.addEventListener('load', send)
    return () => {
      ro.disconnect()
      window.removeEventListener('load', send)
    }
  }, [])

  return null
}
